<template>

    <div>

        <inertia-head :title="title">
        </inertia-head>

        <div class="container py-5">

            <h1 class="h1">{{ title }}</h1>

            <div v-html="content">
            </div>

        </div>
    </div>

</template>

<script>


    export default {
        props: [
            'title',
            'content',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>